import {
  OTP_SENT_ERROR,
  OTP_SENT_SUCCESS,
  SET_COMMUNICATION_REDUCER,
} from "../types/communicationTypes";

const initState = {
  sentOtpSuccess: false,
  sentOtpError: false,
  sentOtpMsg: null,
};

const communicationReducer = (state = initState, action) => {
  switch (action.type) {
    case OTP_SENT_SUCCESS:
      return {
        ...state,
        sentOtpSuccess: true,
        sentOtpError: false,
        sentOtpMsg: action.message || "Otp sent successffully.",
      };
    case OTP_SENT_ERROR:
      return {
        ...state,
        sentOtpSuccess: false,
        sentOtpError: true,
        sentOtpMsg: action.message || "Failed to sent OTP.",
      };
    case SET_COMMUNICATION_REDUCER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default communicationReducer;
